import { useFragment } from '@apollo/client/react';
import { cn } from '@optools/components/ui/utils';
import { BTC_GAME_FRAGMENT } from '@optools/services/operator-gateway/btc/fragments';
import { MediaType } from '@optools/services/operator-gateway/types/generated/graphql';
import { FeedCard } from '@optools/tools/btc-tools/components/broadcast-acquisitions/feed-card';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { RadioTower } from 'lucide-react';

export const Route = createFileRoute('/_auth/btc-tools/schedule/$gamePk/broadcast-acquisitions/')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { gamePk } = useParams({ from: '/_auth/btc-tools/schedule/$gamePk' });

  const gameFragment = useFragment({
    fragment: BTC_GAME_FRAGMENT,
    fragmentName: 'BTCGameFields',
    from: { __typename: 'Game', gamePk },
  });

  const { data: game } = gameFragment;
  const { broadcasts } = game;
  const videoBroadcasts = broadcasts?.filter((item) => item?.mediaType === MediaType.VIDEO) ?? [];

  return (
    <section
      className={cn(
        'h-[calc(100%-42px)]',
        videoBroadcasts.length === 0 && 'grid grid-rows-[auto_1fr]',
      )}>
      <p className="mb-4 text-sm">Manage Broadcast Overrides</p>
      {videoBroadcasts.length > 0 ? (
        <div className="flex flex-col gap-2">
          {videoBroadcasts.map(
            (broadcast) =>
              broadcast?.feedType &&
              broadcast?.mediaId && (
                <FeedCard
                  key={broadcast.mediaId}
                  feedType={broadcast.feedType}
                  gamePk={gamePk}
                  mediaId={broadcast.mediaId}
                />
              ),
          )}
        </div>
      ) : (
        <div
          className="flex items-center justify-center rounded border border-dashed p-4"
          data-testid="empty-video-broadcasts">
          <div className="flex flex-col items-center gap-2">
            <RadioTower className="size-8" />
            <h2>No Video Feeds</h2>
          </div>
        </div>
      )}
    </section>
  );
}
